<template>
	<div class="write-mail">
		<!-- 导航栏 -->
		<van-nav-bar :fixed="true" :title="pageTitle" :left-text="$t('common.cancel')" @click-left="goBack" @click-right="sendMail(false)">
			<template #right>
				<a class="btn-send" :class="!sendable && 'disabled'">{{ $t('email.send') }}</a>
			</template>
		</van-nav-bar>

		<div class="main-content">
			<!-- 写邮件表单 -->
			<div class="write-mail-form">
				<!-- <form> -->

				<!-- 收件人 -->
				<div class="contact-input">
					<p class="input-label">{{ $t('email.to') }}:</p>
					<span v-for="(item, i) in email.toContacts" :key="i" class="contact-item">{{ item.Name || item.Address }}</span>
					<input v-model="email.to" id="toInputEle" ref="toInputEle" class="input-box" type="text" tabindex="1" @input="checkInput($event, 'to')" @keydown.delete="editContact($event, 'to')" />
					<span class="btn-add-contact" @click="selectWXContacts('to')"><i class="iconfont icon-plus-circle"></i></span>
				</div>

				<!-- 抄送人 -->
				<div class="contact-input" v-show="showCc" @click="showBccInput">
					<p class="input-label">{{ ccAndBccExpanded ? $t('email.cc') : `${$t('email.cc')}/${$t('email.bcc')}` }}:</p>
					<span v-for="(item, i) in email.ccContacts" :key="i" class="contact-item">{{ item.Name || item.Address }}</span>
					<input v-model="email.cc" id="ccInputEle" ref="ccInputEle" class="input-box" type="text" tabindex="2" @input="checkInput($event, 'cc')" @keydown.delete="editContact($event, 'cc')" />
					<span class="btn-add-contact" @click="selectWXContacts('cc')"><i class="iconfont icon-plus-circle"></i></span>
				</div>

				<!-- 密送人 -->
				<div class="contact-input" v-show="ccAndBccExpanded && showBcc">
					<p class="input-label">{{ $t('email.bcc') }}:</p>
					<span v-for="(item, i) in email.bccContacts" :key="i" class="contact-item">{{ item.Name || item.Address }}</span>
					<input v-model="email.bcc" id="bccInputEle" ref="bccInputEle" class="input-box" type="text" tabindex="3" @input="checkInput($event, 'bcc')" @keydown.delete="editContact($event, 'bcc')" />
					<span class="btn-add-contact" @click="selectWXContacts('bcc')"><i class="iconfont icon-plus-circle"></i></span>
				</div>

				<!-- 主题 -->
				<div class="contact-input" v-show="showSubject">
					<p class="input-label">{{ $t('email.subject') }}:</p>
					<input v-model="email.subject" class="input-box" type="text" tabindex="4" />

					<span class="btn-add-attachment" v-show="showUploadBtn" @click="openFileUpload">
						<i class="iconfont icon-fujian"></i>
					</span>
				</div>

				<!-- 邮件内容 -->
				<div
					:style="showAttachments && email.fileList.length && (email.fileList.length < 3 ? 'margin-bottom:25.33vw;' : 'margin-bottom:47.5vw;')"
					v-show="showMailContent"
					ref="mailContent"
					class="email-content"
					contenteditable="true"
					id="write-content"
					tabindex="4"
					@touchstart="touchStart"
					@blur="touchBlur"
					v-html="$filters.filterEmailHtml(email.content)"></div>

				<!-- 附件列表 -->
				<div class="email-attachments" v-show="showAttachments && email.fileList.length">
					<van-uploader
						ref="fileUpload"
						upload-icon="plus"
						multiple
						v-model="email.fileList"
						:max-size="30 * 1024 * 1024"
						@oversize="onAttachmentOversize"
						@click-preview="onAttachmentClick"
						@delete="onAttachmentDelete"
						accept="*.*"
						:before-read="attachmentBeforeRead"
						:after-read="attachmentAfterRead"
						:show-upload="showUploadBtn">
						<!-- <template #preview-cover="{ file,content }">
              <div v-if="!content.startsWith('data:image')" class="preview-cover van-ellipsis">{{ file.name }}</div>
            </template> -->
					</van-uploader>
				</div>
				<!-- </form> -->
			</div>

			<!-- 联系人搜索列表 -->
			<div class="contact-search" v-show="contactSearch.showList">
				<div class="contact-info" v-for="(i, index) in contactSearch.listData" :key="index" @click="selectContact(i)">
					<!-- <div class="headpic"><img src="@/assets/img/user-headpic.jpg" alt=""></div> -->
					<div class="headpic">{{ i.nameDisplay.slice(0, 1).toUpperCase() }}</div>
					<div class="info">
						<p>
							<span class="name" v-html="$filters.findStrWrapSpan(i.nameDisplay, contactSearchParams.key)"></span>
							<span v-if="i.email" class="email">({{ i.email }})</span>
						</p>
						<p class="org" v-if="i.section">
							{{ `${i.section}` }}
						</p>
					</div>
				</div>
				<!-- //v-if="i.tenantDeps && i.tenantDeps.length"
								// `${i.tenantDeps[0].ehrCompanyName || i.tenantDeps[0].orgName} ${
								// 	i.tenantDeps[0].positionName && '| ' + i.tenantDeps[0].positionName
								// }`section -->
				<div class="loading-tip" v-show="contactSearch.loading">
					<van-loading>{{ $t('contactSearch.loading') }}</van-loading>
				</div>
				<div class="load-more" v-show="!contactSearch.loading && contactSearch.hasMoreData" @click="contactListLoadMore">
					{{ $t('contactSearch.loadMore') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'
const initData = {
	//是否是名片跳转过来的链接
	isAdd: false,
	// 页面标题，会在 initEmail() 中根据情况自动生成
	pageTitle: '',
	// 是否可发送邮件
	sendable: false,
	// 编辑邮件类型
	operate: '0',
	backNum: 0,
	showSaveDarftConfirm: true,
	defaultMailContent: '',
	showUploadBtn: true,
	//邮件信息
	email: {
		id: '',
		to: '',
		cc: '',
		bcc: '',
		subject: '',
		content: '',
		toContacts: {},
		ccContacts: {},
		bccContacts: {},
		fileList: [],
		IsMeeting: false,
		AssociatedAppointmentId: ''
	},
	// 当前激活的联系人输入框
	currentFocusInput: 'to',
	// 是否展示了抄送和密送输入框
	ccAndBccExpanded: false,
	showCc: true,
	showBcc: false,
	showSubject: true,
	showMailContent: true,
	showAttachments: true,
	verifyEmailDelay: null,
	contactSearchDelay: null,
	contactSearchCancelToken: null,
	// 联系人搜索配置及结果
	contactSearch: {
		hasMoreData: false,
		showList: false,
		listData: [],
		finished: true,
		loading: false
	},
	// 联系人搜索翻页参数
	contactSearchParams: {
		key: '',
		pageNum: 0,
		pageSize: 20
	}
}
export default {
	name: 'WriteMail',
	data() {
		return JSON.parse(JSON.stringify(initData))
	},
	computed: {
		// 获取用户信息
		userInfo() {
			return this.$store.state.User.userInfo
		}
	},
	watch: {
		// 检验是否可发送邮件
		email: {
			handler: function (val, oldVal) {
				this.sendable = Object.keys(val.toContacts).length || Object.keys(val.ccContacts).length || Object.keys(val.bccContacts).length
			},
			deep: true
		}
	},
	updated() {
		const contElm = document.querySelectorAll('#write-content a')
		console.log(contElm, '遍历=====')
		if (contElm.length) {
			for (let i = 0; i < contElm.length; i++) {
				const obj = this.$utils.getUrlParamsBystr(contElm[i].href)
				if (obj.source && obj.source === 'email' && !obj.ticket) {
					contElm[i].href = contElm[i].href + '&ticket=' + this.userInfo.Token + '&appcode=admin&deviceType=pc'
				}
			}
		}
	},
	components: {},
	created() {},
	mounted() {},
	beforeRouteEnter(to, from, next) {
		console.log('from:', from.name)
		if (from.name === 'Preview') {
			to.meta.isBack = true
			to.meta.showSaveDarftConfirm = true
		} else {
			to.meta.isBack = false
		}
		next()
	},
	activated() {
		console.log('activated:', this.$route)
		this.showSaveDarftConfirm = true
		if (!this.$route.meta.isBack) {
			// 要把data中的初始值重置掉
			this.backNum = 0
			this.showUploadBtn = true
			this.sendable = false
			this.currentFocusInput = 'to'
			this.ccAndBccExpanded = false
			this.showCc = true
			this.showBcc = false
			this.showSubject = true
			this.showMailContent = true
			this.showAttachments = true
			this.verifyEmailDelay = null
			this.contactSearchDelay = null
			this.contactSearchCancelToken = null
			this.email = JSON.parse(JSON.stringify(initData.email))
			this.contactSearch = JSON.parse(JSON.stringify(initData.contactSearch))
			this.contactSearchParams = JSON.parse(JSON.stringify(initData.contactSearchParams))

			// 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
			this.initEmail()
			// 当前激活的联系人输入框
		}
		// 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
		// this.$route.meta.isBack = false
	},
	beforeRouteLeave(to, from, next) {
		console.log('confirm:', this.showSaveDarftConfirm)

		// 如果没写收件人和内容，则不提示
		let email = this.email
		let emailContent = this.$refs.mailContent.innerHTML
		let contentNoModify = false
		if (
			!Object.keys(email.toContacts).length &&
			!Object.keys(email.ccContacts).length &&
			!Object.keys(email.bccContacts).length &&
			!Object.keys(email.fileList).length &&
			!email.subject &&
			emailContent === this.defaultMailContent
		) {
			this.showSaveDarftConfirm = false
			contentNoModify = true
		}
		// 如果是进预览页和发完邮件返回则不提示保存草稿
		if (!this.showSaveDarftConfirm) {
			// 如果是未填写邮件内容，则要删除草稿
			if (contentNoModify && this.operate !== '4') {
				this.deleteDarft()
			}
			next()
			return
		}

		next(false)
		this.backNum++
		// 实现第2次返回时关闭确认保存草稿弹窗
		if (this.backNum > 1) {
			this.$dialog.close()
			this.backNum = 0
			return
		}
		console.log('backnum:', this.backNum)
		this.$dialog
			.confirm({
				message: this.$t('writeMail.saveTip'),
				confirmButtonText: this.$t('writeMail.saveOk'),
				cancelButtonText: this.$t('writeMail.saveNo'),
				closeOnClickOverlay: true,
				closeOnPopstate: false,
				beforeClose: (action, done) => {
					// overlay cancel confirm
					if (action === 'overlay') {
						done(false)
						this.$dialog.close()
					} else {
						done()
					}
					this.backNum = 0
				}
			})
			.then(() => {
				console.log('saveDarft')
				// 保存草稿
				this.sendMail('saveDarft')
			})
			.catch(() => {
				next()
				this.$router.go(-1)
				// 编辑草稿时不做删除操作，直接返回
				if (this.operate === '4') return
				// 删除草稿
				this.deleteDarft()
			})
		console.log(this.k)
	},
	methods: {
		touchStart(e) {
			if (e.target.tagName === 'img') {
				e.preventDefault()
				return false
			}
		},
		touchBlur(e) {
			console.log(e, 'blur')
			let content = this.$refs.mailContent.innerHTML
			console.log(content)
			var parser = new DOMParser()
			var doc = parser.parseFromString(content, 'text/html')

			this.parseNode(doc.body)

			this.$refs.mailContent.innerHTML = doc.body.innerHTML
		},

		linkify(inputText) {
			var replacedText, replacePattern1, replacePattern2, replacePattern3
			replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim
			replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>')
			replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim
			replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>')
			return replacedText
		},

		parseNode(node) {
			if (node.nodeType === 3) {
				if (node.parentNode && node.parentNode.nodeName.toLowerCase() != 'a') {
					var linkedText = this.linkify(node.textContent)
					// Node.TEXT_NODE
					var tempDiv = document.createElement('div')
					tempDiv.innerHTML = linkedText

					while (tempDiv.firstChild) {
						node.parentNode.insertBefore(tempDiv.firstChild, node)
					}

					node.parentNode.removeChild(node)
				}
			} else if (node.childNodes && node.childNodes.length) {
				for (var i = 0; i < node.childNodes.length; i++) {
					this.parseNode(node.childNodes[i])
				}
			}
		},
		goBack() {
			this.$router.go(-1)
		},
		// 初始化页面
		initEmail() {
			// 初始化微信
			this.$wx.init()
			// SourceEmailId: 源邮件标识（回复和转发邮件必须）
			let SourceEmailId = this.$route.query.mailid
			// etype类型: 0-新邮件；1-回复邮件；2-回复全部；3-转发邮件；4-编辑草稿邮件；（默认0）
			let Operate = this.$route.query.etype || '0'
			// ftype类型(当前所在目录):1-收件箱；2-草稿箱；3-已发送；4-已删除；5-垃圾箱
			this.ftype = this.$route.query.ftype || '1'
			this.operate = Operate
			const createDartLoading = this.$toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				message: this.$t('email.mailLoading')
			})
			//接收人
			if (this.ftype == '0') {
				let addEmail = localStorage.getItem('ToEmail') || ''
				let addName = localStorage.getItem('ToName') || ''
				if (addEmail && addName) {
					this.$set(this.email[`${this.currentFocusInput}Contacts`], addEmail.toUpperCase(), {
						Name: decodeURIComponent(addName),
						Address: addEmail
					})
					// this.email.toContacts.push({ Name: decodeURIComponent(addName), Address: addEmail })
					localStorage.setItem('ToName', '')
					localStorage.setItem('ToEmail', '')
				}
			}

			// 生成页面标题
			switch (Operate) {
				case '1':
				case '2':
					this.pageTitle = this.$t('email.replyTitle')
					break
				case '3':
					this.pageTitle = this.$t('email.forwardTitle')
					break
				default:
					// 0,4
					this.pageTitle = this.$t('email.title')
			}

			// 获取参数，创建邮件草稿
			this.$api
				.createNewEmailDart({ SourceEmailId, Operate })
				.then((res) => {
					let mailInfo = res.Data
					console.log('res:', res)

					// 处理输入焦点定位
					switch (Operate) {
						// 回复和编辑草稿时光标定位到内容输入框
						case '1':
						case '2':
						case '4': {
							this.$refs.mailContent.focus()
							break
						}
						// 新建邮件和转发时(0,3)光标定位到收件人输入框
						default: {
							this.$refs.toInputEle.focus()
						}
					}

					// 处理接口数据到页面中
					this.email.id = mailInfo.Id
					// 收件人
					mailInfo.ToRecipients.forEach((v, k) => {
						this.email.toContacts[v.Address.toUpperCase()] = v
					})

					// 抄送人
					mailInfo.CcRecipients.forEach((v, k) => {
						this.email.ccContacts[v.Address.toUpperCase()] = v
					})
					// 密送人
					mailInfo.BccRecipients.forEach((v, k) => {
						this.email.bccContacts[v.Address.toUpperCase()] = v
					})

					// 如果抄送人或密送人不为空，则展开密送人
					if (mailInfo.CcRecipients.length || mailInfo.BccRecipients.length) {
						this.showBcc = true
						this.ccAndBccExpanded = true
					}

					// 主题
					this.email.subject = mailInfo.Subject
					this.defaultMailContent = `<br><br><br><br><br><div>发自${this.userInfo?.UserName}的移动端邮箱</div>`
					// 如果是编辑草稿，则不加往内容中加用户签名，且将默认内容改成邮件内容
					if (Operate === '4') {
						this.defaultMailContent = mailInfo.Body.Text
						this.email.content = mailInfo.Body.Text
					} else {
						this.email.content = this.defaultMailContent + mailInfo.Body.Text
					}
					//是否是会议邮件
					this.email.IsMeeting = mailInfo.IsMeeting
					//会议邮件标识
					this.email.AssociatedAppointmentId = mailInfo.AssociatedAppointmentId

					// 附件处理
					if (mailInfo.Attachments.length) {
						mailInfo.Attachments.forEach((file) => {
							if (!file.IsInline) {
								this.email.fileList.push({
									url: location.origin + '/api' + file.Attach_ServerPath,
									isImage: file.Attach_Type.startsWith('image/'),
									file: {
										type: file.Attach_Type,
										name: file.Attach_Name,
										size: file.Attach_Size
									},
									result: file
								})
							}
						})
					}
				})
				.finally(() => {
					createDartLoading.clear()
				})
		},
		// 删除草稿
		deleteDarft() {
			// 删除草稿
			this.$api
				.deletEMAList({
					EmailIds: [this.email.id],
					DeleteMode: 0 //0-强制删除;1-软删除;2-移动删除(默认0)
				})
				.then((res) => {
					console.log('删除草稿成功')
					// 广播需要刷新列表的消息
					// this.$bus.$emit('needRefreshEmailList', false)
				})
				.catch(() => {
					// 删除草稿失败
				})
		},
		// 打开企微选人
		async selectWXContacts(type) {
			let data = await this.$wx.selectEnterpriseContact()
			console.log(data)
			if (data?.userList) {
				let users = data.userList
				console.log('users:', users)
				// 如果选择了人才处理
				if (users.length > 0) {
					let temp = []
					users.forEach((contact) => {
						// 有email的直接加到联系人列表，没有email的集中去请求接口获取email
						if (contact.email) {
							this.$set(this.email[`${type}Contacts`], contact.email.toUpperCase(), {
								Name: contact.name,
								Address: contact.email
							})
						} else {
							temp.push(contact.id)
						}
					})
					console.log('temp:', temp)
					if (temp.length > 0) {
						// 通过接口去获取联系人的邮箱
						this.$api
							.getUserinfoByEmpNo(temp)
							.then((res) => {
								if (res.Data) {
									if (temp.length !== res.Data.length) {
										// 提示部分选择被过滤
										this.$notify({ type: 'warning', message: this.$t('email.selectFiltered') })
									}
									if (res.Data.length > 0) {
										res.Data.forEach((contact) => {
											this.$set(this.email[`${type}Contacts`], contact.email.toUpperCase(), {
												Name: contact.nameDisplay,
												Address: contact.email
											})
										})
										// 强制更新一下，解决选人后视图未更新问题
										this.$forceUpdate()
									}
								} else {
									console.log('获取已选人员信息失败')
								}
							})
							.catch(() => {
								console.log('获取已选人员信息失败')
							})
					}
				}
			}
			this.$refs[`${type}InputEle`].blur()
			this.$refs[`${type}InputEle`].focus()
		},
		// 格式化收件人/抄收人数据成发送邮件需要的格式，发送时只能有Address属性
		formatEmails(mails) {
			let temp = []
			Object.keys(mails).map((key) => {
				temp.push({ Address: mails[key].Address })
			})
			return temp
		},
		// 转换email.Files中的附件数据为发送邮件时需要的格式
		convertAttachData() {
			let temp = [],
				obj = this.email.fileList
			Object.keys(obj).map((key) => {
				temp.push(obj[key].result)
			})
			return temp
		},
		// 发送邮件和保存草稿
		sendMail(isSaveDarft) {
			if (!isSaveDarft && !this.sendable) return
			console.log('send mail.')
			let email = this.email

			// 请求参数处理
			let opts = {
				Id: email.id,
				ToRecipients: this.formatEmails(email.toContacts),
				CcRecipients: this.formatEmails(email.ccContacts),
				BccRecipients: this.formatEmails(email.bccContacts),
				Subject: email.subject,
				Attachments: this.convertAttachData(),
				// FixTime: timeSendTime, //定时发送参数
				// IsReadReceiptRequested: this.readReceipt, //已读回执参数
				//会议邮件相关字段
				IsMeeting: email.IsMeeting,
				AssociatedAppointmentId: email.AssociatedAppointmentId,

				Body: {
					bodyType: 1,
					Text: this.$refs.mailContent.innerHTML // 邮件内容
				}
				//邮件重要性
				// Importance: email.Importance ? parseInt(email.Importance) : 1
			}

			const sendMailLoading = this.$toast.loading({
				duration: 0,
				forbidClick: true
			})
			if (isSaveDarft) {
				// 保存草稿
				this.$api
					.saveEmailDarft(opts)
					.then((res) => {
						console.log('保存草稿成功:', res)
						this.$toast(this.$t('writeMail.saveSuccess'))
						this.showSaveDarftConfirm = false
						// 如果返回的是草稿目录，则广播需要刷新列表
						if (this.ftype === '2') {
							// 广播需要刷新列表的消息
							this.$bus.$emit('needRefreshEmailList', true)
						}
						this.goBack()
					})
					.catch(() => {
						this.$toast(this.$t('writeMail.saveFail'))
					})
					.finally(() => {
						sendMailLoading.clear()
					})
			} else {
				// 发送邮件
				this.$api
					.sendEmail(opts)
					.then((res) => {
						console.log('发送成功:', res)
						this.$toast(this.$t('email.sendSuccess'))
						this.showSaveDarftConfirm = false
						this.goBack()
						// 广播需要刷新列表的消息
						this.$bus.$emit('needRefreshEmailList', true)
					})
					.catch(() => {
						this.$toast(this.$t('email.sendFailed'))
					})
					.finally(() => {
						sendMailLoading.clear()
					})
			}
		},
		openFileUpload() {
			this.$refs.fileUpload.chooseFile()
		},
		// 附件超出大小处理
		onAttachmentOversize(file) {
			console.log(file)
			// 单个附件不能超过30M
			this.$toast(this.$t('attachment.overFileMaxSize'))
		},
		// 点击附件时触发
		onAttachmentClick(file) {
			console.log(file)
			let onlinePreviewFileType = {
				txt: 'txt',
				doc: 'doc,docx',
				ppt: 'ppt,pptx',
				xls: 'xls,xlsx',
				pdf: 'pdf',
				mp3: 'mp3',
				wav: 'wav',
				mp4: 'mp4'

				// jpg: 'jpg',
				// jpeg: 'jpeg',
				// png: 'png',
				// gif: 'gif',
				// bmp: 'bmp',
				// xbm: 'xbm',
				// tif: 'tif',
				// tiff: 'tiff',
				// svgz: 'svgz',
				// avif: 'avif',
				// pjpeg: 'pjpeg'
			}
			let fileName = file.file.name
			let fileType = file.file.type
			let isPreviewType = false
			let curFileType = ''
			// 如果文件名中不包含'.',则没法判断类型，直接不允许预览
			// 否则取最后一个扩展名为文件类型，用来判断是否可预览
			if (fileName.indexOf('.') !== -1) {
				curFileType = fileName.split('.').slice(-1)[0]
				isPreviewType = Object.keys(onlinePreviewFileType).some((type) => {
					return curFileType.indexOf(type) !== -1
				})
			}

			console.log('isPreviewType:', isPreviewType, curFileType)
			if (isPreviewType) {
				// 一定要加4次encode
				let downUrl = encodeURIComponent(encodeURIComponent(encodeURIComponent(location.origin + '/api' + file.result.Attach_ServerPath + `&emailid=${encodeURIComponent(this.email.id)}`)))
				let empNo = this.userInfo.empNo
				// TODO: 可以处理预览链接失效时间，将请求结果缓存起来，不用每次都去请求
				const previewLoading = this.$toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true
				})
				this.$api
					.getFilePreviewUrl({ downUrl, fileType: curFileType, empNo })
					.then((res) => {
						if (res.Data) {
							this.showSaveDarftConfirm = false
							this.$router.push({ path: '/preview', query: { previewurl: res.Data } })
						}
					})
					.catch(() => {
						// TODO: 添加预览失败提醒
					})
					.finally(() => {
						previewLoading.clear()
					})
			} else if (fileType.indexOf('image') === -1) {
				console.log('该文件不支持预览')
				this.$notify({ type: 'warning', message: this.$t('attachment.noSupportPreview') })
			} else {
				if (file.imageIndex !== undefined) {
					this.$imagePreview({
						images: this.imgAttachments,
						startPosition: file.imageIndex
					})
				}
			}
		},
		// 删除附件时触发
		onAttachmentDelete(file) {
			console.log(file)
			if (file.result) {
				this.$api
					.deleteAttachment({ EmailId: this.email.id, AttachmentId: file.result.Id, IsMeeting: false })
					.then((res) => {
						console.log('附件删除成功')
					})
					.catch(() => {
						console.log('附件删除失败:', file)
					})
			}
		},
		// 上传前处理
		attachmentBeforeRead(file) {
			console.log('fileList:', this.email.fileList)
			console.log(file)
			let attachTotalSize = this.email.fileList.reduce((total, next) => {
				if (next.status !== 'failed') {
					return total + next.file.size
				} else {
					return total
				}
			}, 0)
			let fileTotalSize = 0
			if (file.length) {
				fileTotalSize = file.reduce((total, next) => {
					return total + next.size
				}, 0)
			} else {
				fileTotalSize = file.size
			}
			console.log('size1:', attachTotalSize, 'size2:', fileTotalSize)
			// 如果附件总大小大于100M，则不允许添加文件了
			if (attachTotalSize + fileTotalSize > 100 * 1024 * 1024) {
				this.$toast(this.$t('attachment.overMaxSize'))
				return false
			} else {
				return true
			}
		},
		// 选择文件后上传
		attachmentAfterRead(file) {
			// 开始上传时隐藏上传按钮，上传完成后再显示
			this.showUploadBtn = false
			if (file.length) {
				file.forEach((v, k) => {
					v.status = 'uploading'
					v.message = this.$t('attachment.uploading')
				})
				this.multiAttachmentFileUpload(file)
			} else {
				file.status = 'uploading'
				file.message = this.$t('attachment.uploading')
				this.attachmentUpload(file)
			}
		},
		// 多附件一个接一个上传(这样上传才不容易出现上传失败的情况)
		multiAttachmentFileUpload(files, index = 0) {
			let curFile = files[index]
			let data = new FormData()
			data.append('Id', this.email.id)
			data.append('file', curFile.file)
			this.$api
				.fileUploader(data)
				.then((res) => {
					if (res?.Data?.length) {
						curFile.status = 'done'
						curFile.result = res.Data[0]
					}
					console.log('上传成功:', res)
				})
				.catch(() => {
					curFile.status = 'failed'
					curFile.message = this.$t('attachment.uploadFailed')
					console.log('上传失败')
				})
				.finally(() => {
					if (index < files.length - 1) {
						this.multiAttachmentFileUpload(files, index + 1)
					} else {
						// 多个文件上传结束后显示上传按钮
						this.showUploadBtn = true
					}
				})
		},
		// 单附件上传
		attachmentUpload(file) {
			let data = new FormData()
			data.append('Id', this.email.id)
			data.append('file', file.file)
			this.$api
				.fileUploader(data)
				.then((res) => {
					if (res?.Data?.length) {
						file.status = 'done'
						file.result = res.Data[0]
					}
					console.log('上传成功:', res)
				})
				.catch(() => {
					file.status = 'failed'
					file.message = this.$t('attachment.uploadFailed')
					console.log('上传失败')
					// 找到上传失败的文件并从预览列表中删除
					// let fileIndex = this.email.fileList.findIndex((v) => {
					// 	return v.file.name === file.file.name
					// })
					// if (this.flieIndex !== -1) {
					// 	this.email.fileList.splice(fileIndex, 1)
					// }
				})
				.finally(() => {
					this.showUploadBtn = true
				})
		},
		// onContactSearchLoad() {},
		// 显示密送输入框并让抄送输入框获得焦点
		showBccInput() {
			this.ccAndBccExpanded = true
			this.showBcc = true
			this.$refs.ccInputEle.focus()
		},
		// 请求接口获取联系人数据
		contactSearchFn(isConcat = false) {
			this.contactSearch.loading = true
			this.$api
				.contactSearch(this.contactSearchParams)
				.then((res) => {
					if (res?.Data?.rows) {
						if (isConcat) {
							this.contactSearch.listData = [...this.contactSearch.listData, ...res.Data.rows]
						} else {
							this.contactSearch.listData = res.Data.rows
						}
						// 当前页是最后一页时不再显示“加载更多...”按钮
						if (res.Data.page < res.Data.total) {
							this.contactSearch.hasMoreData = true
						} else {
							this.contactSearch.hasMoreData = false
						}
					}
				})
				.catch(() => {
					// 如果加载更多时失败，则页码不变
					if (this.contactSearchParams.pageNum > 0) {
						this.contactSearchParams.pageNum--
					}
				})
				.finally(() => {
					this.contactSearch.loading = false
				})
		},
		// 联系人输入搜索函数
		contactInputSearch() {
			if (this.contactSearchDelay) {
				clearTimeout(this.contactSearchDelay)
			}
			// 延迟600毫秒再进行搜索，避免连续输入时不断搜索
			this.contactSearchDelay = setTimeout(this.contactSearchFn, 600)
		},
		// 联系人搜索列表加载更多
		contactListLoadMore() {
			this.contactSearchParams.pageNum++
			if (this.contactSearchParams.pageNum === 1) {
				this.contactSearchFn(false)
			} else {
				this.contactSearchFn(true)
			}
			this.$refs[`${this.currentFocusInput}InputEle`].focus()
		},
		selectContact(contact) {
			// 获取当前要填充的联系人组(toContacts/ccContacts/bccContacts)
			if (contact?.email) {
				// TODO: 可以添加联系人重复时的提示
				this.$set(this.email[`${this.currentFocusInput}Contacts`], contact.email.toUpperCase(), {
					Name: contact.nameDisplay,
					Address: contact.email
				})
				this.email[this.currentFocusInput] = ''
				this.$refs[`${this.currentFocusInput}InputEle`].focus()
				// 隐藏搜索列表
				this.contactSearch.showList = false
				// 恢复表单显示
				this.showCc = this.showBcc = this.showSubject = this.showMailContent = this.showAttachments = true
			} else {
				// 提示用户没有邮箱
				this.$notify({ type: 'warning', message: this.$t('email.noEmail') })
			}
		},
		// 按删除键时编辑已输入的最后一个联系人
		editContact(e, type) {
			if (e.keyCode === 8) {
				// 按删除键时如果输入框没有内容了，则删除已完成输入的邮箱
				if (!this.email[type] && Object.keys(this.email[`${type}Contacts`]).length) {
					// this.email[`${type}Contacts`].pop()
					let key = Object.keys(this.email[`${type}Contacts`]).slice(-1)
					console.log('key:', key[0])
					this.$delete(this.email[`${type}Contacts`], key[0])
				}
			}
		},
		// 检测联系人输入并做对应处理
		checkInput(e, type) {
			// 设置当前激活的联系人输入框
			this.currentFocusInput = type
			if (this.verifyEmailDelay) {
				clearTimeout(this.verifyEmailDelay)
			}
			console.log('keycode:', e)
			// if (e.inputType === 'deleteContentBackward') {
			// if (e.keyCode === 8) {
			// 	// 按删除键时如果输入框没有内容了，则删除已完成输入的邮箱
			// 	if (!this.email[type] && this.email[`${type}Contacts`].length) {
			// 		this.email[`${type}Contacts`].pop()
			// 	}
			// } else {
			// 正常情况下,都来验证是否输入了正确的邮箱地址
			this.verifyEmailDelay = setTimeout(() => {
				let _email = this.email[type].trim()
				if (this.verifyEmail(_email)) {
					console.log('是正确的邮箱')
					// this.email[`${type}Contacts`].push(_email)
					let key = _email.toUpperCase()
					if (this.email[`${type}Contacts`][key]) {
						// 提示联系人已存在
						this.$notify({ type: 'warning', message: this.$t('email.contactExists') })
					} else {
						this.email[`${type}Contacts`][key] = { Address: _email }
					}
					this.email[type] = ''
					// 恢复表单显示
					this.showCc = this.showBcc = this.showSubject = this.showMailContent = this.showAttachments = true
				}
			}, 700)
			// }

			// 对输入进行快捷搜索，删除已输入的字符时也要搜索
			// 如果输入的字符串中包含"@"，则判断是在输入邮箱地址，则不进行搜索
			let searchKey = this.email[type].trim()
			if (!searchKey) {
				// 恢复表单显示
				this.showCc = this.showBcc = this.showSubject = this.showMailContent = this.showAttachments = true
			}
			if (searchKey && searchKey.indexOf('@') < 0) {
				// 搜索联系人
				this.contactSearchParams.key = searchKey
				this.contactSearchParams.pageNum = 0
				this.contactSearch.showList = true
				this.contactSearchFn()

				// 根据在不同输入框中搜索的情况，控制表单的显示隐藏
				switch (type) {
					case 'to': {
						this.showCc = false
						this.showBcc = false
					}
					case 'cc': {
						this.showBcc = false
					}
					default: {
						this.showSubject = false
						this.showMailContent = false
						this.showAttachments = false
					}
				}
			} else {
				this.contactSearch.showList = false
			}
		},
		/* 校验输入的邮件地址 */
		verifyEmail(_email) {
			// 如果输入为空不做校验
			let email = _email.trim()
			if (!email) return
			// 用邮箱校验正则进行校验
			// 只允许英文字母、数字、下划线、点、英文句号、以及中划线组成
			// const emailReg1 = /^[a-zA-Z0-9_\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
			const emailReg1 = /^[a-zA-Z0-9_\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]{2,6})+$/
			// /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
			// 名称允许汉字、字母、数字，域名只允许英文域名
			const emailReg2 = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
			// 通过验证返回true
			return emailReg1.test(email)
		}
	}
}
</script>

<style lang="scss">
.write-mail {
	height: 100%;
	.btn-send {
		font-size: 16px;
		display: block;
		line-height: 30px;
		padding-left: 8px;
		text-align: center;
		color: $main_color;
		&.disabled {
			opacity: 0.3;
		}
	}

	.main-content {
		height: 100%;
		display: flex;
		flex-direction: column;
		.email-attachments {
			position: fixed;
			bottom: 0;
			padding-left: 16px;
			background: #fff;
			padding-top: 10px;
			width: 100%;
			max-height: 178px;
			overflow-y: auto;
			.van-uploader__file {
				.van-uploader__preview-cover {
					// display: none;
				}
				.van-uploader__file-icon {
					// display: none;
				}
			}
			.van-uploader__preview {
				.van-uploader__preview-delete {
					border-radius: 50%;
				}
				.van-uploader__preview-delete-icon {
					top: -1px;
					right: -1.1px;
				}
			}
			.van-uploader__preview-image,
			.van-uploader__file {
				width: 107px;
				height: 74px;
				background: #fafafb;
				border: 1px solid #ccc;
				border-radius: 2px;
			}
			.van-uploader__upload {
				width: 109px;
				height: 76px;
				background: #fafafb;
				border: 1px solid #ccc;
				border-radius: 2px;
			}
			.van-uploader__upload-icon {
				font-size: 18px;
				color: #999;
			}
		}
	}

	// 写邮件详情表单样式
	.write-mail-form {
		padding-top: 46px;
		.contact-input {
			position: relative;
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			padding: 0 35px 0 16px;
			border-bottom: 1px solid #eaeaea;
			min-height: 36px;
			padding-top: 5px;
			.input-label {
				color: $font_color3;
				margin: 0 8px 0 0;
			}
			.contact-item {
				background: $main_color;
				border-radius: 2px;
				// margin-right: 8px;
				padding: 0 8px;
				line-height: 24px;
				color: #fff;
				margin: 6px 8px 6px 0;
				max-width: 200px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			.input-box {
				border: none;
				flex: 1 1 30px;
				height: 36px;
				color: #333;
			}
			.btn-add-contact,
			.btn-add-attachment {
				position: absolute;
				top: 5px;
				right: 5px;
				width: 30px;
				line-height: 36px;
				text-align: center;
				i {
					font-size: 18px;
					margin: 0 auto;
				}
			}
		}
		.email-content {
			padding: 16px;
			outline: none;
			overflow-x: auto;
			font-size: initial;
			// 详情内容样式重置
			a {
				text-decoration: underline;
			}
			line-height: normal;
			min-height: 400px;
			// 邮件内容约束样式
			/* 以下三行代码的作用：
      1、邮件内容中如果有长单词进行自动换行；
      2、邮件内容中有样式white-space：pre等代码时进行覆盖使内容换行；
       */
			word-wrap: break-word;
			* {
				white-space: normal !important;
			}
			table {
				max-width: 100%;
			}
			img {
				max-width: 100%;
				height: auto !important;
			}
			.table-mini-screen {
				min-width: 800px;
			}
		}
	}

	// 联系人搜索列表样式
	.contact-search {
		flex: 1;
		overflow: hidden;
		overflow-y: auto;
		min-height: 350px;
		.contact-info {
			position: relative;
			padding: 15px 16px 15px 60px;
			border-bottom: 1px solid $line_color;
			&:hover {
				background-color: $module_bg_color;
			}
			.headpic {
				position: absolute;
				left: 16px;
				top: 16px;
				width: 36px;
				height: 36px;
				margin-right: 10px;
				border-radius: 50%;
				overflow: hidden;
				background: $main_color;
				text-align: center;
				line-height: 36px;
				font-size: 20px;
				font-weight: bold;
				color: #fff;
				img {
					width: 36px;
					height: auto;
				}
			}
			.info {
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				height: 39px;
				p {
					// display: flex;
					margin: 0;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.name {
					flex: 0 0 70px;
					padding-right: 8px;
					// max-width: 50%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					font-size: 16px;
					font-weight: bold;
					> span {
						color: $main_color;
					}
				}
				.email {
					flex: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					color: $font_color3;
				}
				.org {
					margin-top: 5px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
		.load-more {
			line-height: 45px;
			text-align: center;
			color: $main_color;
			&:hover {
				color: $main_click_color;
			}
		}
		.loading-tip {
			text-align: center;
			margin-top: 8px;
		}
	}
}
</style>
